<template>
  <div class="q_mar_b100px">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" style="height: 70vw;border-radius:0">
      <van-swipe-item v-for="(item, index) in bannerList" :key="index">
        <!--        <van-image width="100%" height="100%" fit="cover" :src="item.url" @click="bannerLink(item.link)"/>-->
        <img :src="convertImg(item.url)" style="width:100%;height:100%;"/>
      </van-swipe-item>

    </van-swipe>
    <div class="q_pad_lr15px q_mar_t15px">
      <div class="q_icon_home q_mar_t40px q_center">
        <div class="q_inlineblock q_mar_b10px" style="width: 25%;" @click="goToActiday()">
          <van-image fit="cover" :src="require('../../assets/image/icon_hdrc.png')"/>
          <div class="q_text_s q_mar_t3px">活动日程</div>
        </div>
        <div class="q_inlineblock q_mar_b10px" style="width: 25%;" @click="goToSpeedlist()">
          <van-image fit="cover" :src="require('../../assets/image/icon_axmj.png')"/>
          <div class="q_text_s q_mar_t3px">爱心捐款</div>
        </div>
        <div class="q_inlineblock q_mar_b10px" style="width: 25%;" @click="goToJoin()">
          <van-image fit="cover" :src="require('../../assets/image/icon_jrxh.png')"/>
          <div class="q_text_s q_mar_t3px">加入中队</div>
        </div>
        <div class="q_inlineblock q_mar_b10px" style="width: 25%;" @click="goToExchange()">
          <van-image fit="cover" :src="require('../../assets/image/icon_axdh.png')"/>
          <div class="q_text_s q_mar_t3px">爱心兑换</div>
        </div>
        <div class="q_inlineblock q_mar_b10px" style="width: 25%;" @click="goToSignday()">
          <van-image fit="cover" :src="require('../../assets/image/icon_mrqd.png')"/>
          <div class="q_text_s q_mar_t3px">每日签到</div>
        </div>
        <div class="q_inlineblock q_mar_b10px" style="width: 25%;" @click="goToLame()">
          <van-image fit="cover" :src="require('../../assets/image/icon_zyzpx.png')"/>
          <div class="q_text_s q_mar_t3px">志愿者培训</div>
        </div>
        <div class="q_inlineblock q_mar_b10px" style="width: 25%;" @click="goToEnterlist()">
          <van-image fit="cover" :src="require('../../assets/image/icon_axqy.png')"/>
          <div class="q_text_s q_mar_t3px">爱心企业</div>
        </div>
        <div class="q_inlineblock q_mar_b10px" style="width: 25%;" @click="goToArtlist()">
          <van-image fit="cover" :src="require('../../assets/image/icon_gydt.png')"/>
          <div class="q_text_s q_mar_t3px">公益动态</div>
        </div>
      </div>
      <van-row class="q_center q_shadow_gray q_mar_t30px" style="padding: 4vw 2.666667vw;border-radius: 1.333334vw;">
        <van-col span="6">
          <div class="q_color_default q_text_xl q_bold q_mar_b5px" v-text="userCount">1283</div>
          <div class="q_color_gray q_text_s">志愿者人数</div>
        </van-col>
        <van-col span="6">
          <div class="q_color_default q_text_xl q_bold q_mar_b5px" v-text="deptCount">1283</div>
          <div class="q_color_gray q_text_s">队伍数量</div>
        </van-col>
        <van-col span="6">
          <div class="q_color_default q_text_xl q_bold q_mar_b5px" v-text="userActivityCount">58283</div>
          <div class="q_color_gray q_text_s">活动人次</div>
        </van-col>
        <van-col span="6">
          <div class="q_color_default q_text_xl q_bold q_mar_b5px" v-text="userActivityTimeLong">89967283</div>
          <div class="q_color_gray q_text_s">服务时长</div>
        </van-col>
      </van-row>
      <van-row gutter="10" class="q_mar_t15px">
        <!--队伍排行-->
        <van-col span="12">
          <van-image width="100%" fit="cover" :src="require('../../assets/image/dw.png')" @click="GotoRanking()"/>
        </van-col>
        <!--个人排行-->
        <van-col span="12">
          <van-image width="100%" fit="cover" :src="require('../../assets/image/gr.png')"
                     @click="GotoRankingPersonnel()"/>
        </van-col>
      </van-row>
      <!--      <div class="q_mar_t30px">-->
      <!--        <div class="q_mar_b15px">-->
      <!--          <span class="q_text_l q_bold">推荐活动</span>-->
      <!--          <span class="q_color_gray q_text_s q_flo_right q_mar_t3px" @click="goToActivity()">查看更多</span>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <!--    <div class="q_center q_mar_t30px" v-if="activityList.length == 0">-->
    <!--      <img src="../../assets/image/none.png" style="width: 26vw;"/>-->
    <!--      <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>-->
    <!--    </div>-->
    <!--    <div class="q_mar_l15px" style="overflow-x: scroll;overflow-y: hidden;display: flex;">-->
    <!--      <div v-for="item in activityList" class="q_acti" @click="goToActivdea(item.id)">-->
    <!--        <van-image fit="cover" :src="item.banner"/>-->
    <!--        <div class="q_text_m q_bold q_mar_t10px q_moit2 q_justify q_moit1">{{ item.name }}</div>-->
    <!--        <div class="q_color_gray q_text_s q_mar_t5px q_mar_b10px">{{ item.startTime }}</div>-->
    <!--        <van-button round type="primary" size="small" color="#FF5733">立即报名</van-button>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="q_pad_lr15px">
      <div class="q_mar_t40px">
        <div class="q_mar_b15px">
          <span class="q_text_l q_bold">最新动态</span>
          <span class="q_color_gray q_text_s q_flo_right q_mar_t3px" @click="goToArtlist()">查看更多</span>
        </div>
        <div class="q_center q_mar_t30px" v-if="articleList[0]!=null && articleList[0].length == 0">
          <img src="../../assets/image/none.png" style="width: 26vw;"/>
          <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
        </div>
        <van-swipe class="my-swipe q_new_ond" indicator-color="#FFA693">
          <van-swipe-item v-for="item in articleList">
            <div>
              <div class="q_vertical_left q_mar_b15px" style="width: 100%" v-for="ite in item"
                   @click="goToArtdea(ite.id)">
                <div class="q_inlineblock">
                  <van-image class="q_act_img" fit="cover" :src="ite.pic"/>
                </div>
                <div class="q_mar_l15px q_inlineblock">
                  <div class="q_text_m q_bold q_moit2 q_justify">{{ ite.name }}</div>
                  <div class="q_text_s q_color_gray q_mar_t10px">{{ ite.createTime }}</div>
                </div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <!--      <div class="q_mar_t40px">-->
      <!--        <div class="q_mar_b15px">-->
      <!--          <span class="q_text_l q_bold">爱心商城</span>-->
      <!--          <span class="q_color_gray q_text_s q_flo_right q_mar_t3px" @click="goToMall">查看更多</span>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <!--    <div class="q_mar_l15px q_mar_r1px">-->
    <!--      <div class="q_store" v-for="item in loveGoodsList" @click="goGoodDetails(item)">-->
    <!--        <van-image fit="cover" :src="item.image"/>-->
    <!--        <div class="q_text_m q_bold q_moit1 q_mar_t5px">{{ item.productName }}</div>-->
    <!--        <div class="q_text_l q_bold q_color_red q_mar_t5px">￥{{ item.price }}</div>-->
    <!--      </div>-->
    <!--			<div class="q_store">-->
    <!--				<van-image fit="cover" :src="require('../../assets/image/act.png')" />-->
    <!--				<div class="q_text_m q_bold q_moit1 q_mar_t5px">商品名称商品名称商品名称商品名称</div>-->
    <!--				<div class="q_text_l q_bold q_color_red q_mar_t5px">￥32.00</div>-->
    <!--			</div>-->
    <!--			<div class="q_store">-->
    <!--				<van-image fit="cover" :src="require('../../assets/image/act.png')" />-->
    <!--				<div class="q_text_m q_bold q_moit1 q_mar_t5px">商品名称商品名称商品名称商品名称</div>-->
    <!--				<div class="q_text_l q_bold q_color_red q_mar_t5px">￥32.00</div>-->
    <!--			</div>-->
    <!--			<div class="q_store">-->
    <!--				<van-image fit="cover" :src="require('../../assets/image/act.png')" />-->
    <!--				<div class="q_text_m q_bold q_moit1 q_mar_t5px">商品名称商品名称商品名称商品名称</div>-->
    <!--				<div class="q_text_l q_bold q_color_red q_mar_t5px">￥32.00</div>-->
    <!--			</div>-->
    <!--    </div>-->


    <!--认证弹框-->
<!--    <van-dialog v-model="user.isBankAuth=='0'" confirm-button-text="立即认证" @confirm="goToAuth"-->
<!--                :before-close="beforeClose">-->
<!--      <img src="../../assets/image/bank_auth.png" style="width: 100%;"/>-->
<!--    </van-dialog>-->
  </div>
</template>

<script>
import Vue from 'vue';
import {Lazyload} from 'vant';
import {getIndexData} from "@/api";
import {publicKey} from "@/utils/request";
import {upArticleById} from "@/api/article";
import {JSEncrypt} from 'jsencrypt'
import {getUrlKey, wxCloseShare} from "@/utils/jiutang";
import {getLoginUser} from "@/api/login";

Vue.use(Lazyload);


export default {
  name: 'Home',
  props: {
    msg: String
  },
  data() {
    return {
      //立即报名状态
      remark: '',
      //轮播图数据
      bannerList: [],
      //活动数据
      activityList: [],
      //最新动态数据
      articleList: [],
      //爱心商城列表
      loveGoodsList: [],
      //当前登录用户数据
      user: {},
      // 志愿者人数
      userCount: 0,
      // 队伍数量
      deptCount: 0,
      // 活动人次
      userActivityCount: 0,
      // 服务时长
      userActivityTimeLong: 0
    }
  },
  created() {
    // getLoginUser().then(res => {
    //   this.user = res.data
    // }).then(() => {
    //   this.init()
    // })
    let token = getUrlKey("token")
    if (token) {
      this.$store.dispatch("Login", token)
    }
    wxCloseShare()
    this.init()
  },
  methods: {
    beforeClose(action, done) {
      done(false)
    },
    /**
     * 立即认证
     */
    goToAuth() {
      this.$router.push({
        path: '/download'
      });
    }
    ,
    /**
     * 获取爱心商城数据
     */
    getGoodss() {
      // axios.get(mallApiUrl + "/volunteer/getGoods").then(response => {
      //   console.log('商城数据', response)
      //   this.loveGoodsList = response.data.data
      // })
    }
    ,
    /**
     * 初始化
     */
    init() {
      this.$modal.loading()
      //获取首頁信息
      getIndexData().then((res) => {
        this.bannerList = res.data.bannerList
        this.activityList = res.data.activityList
        this.articleList = res.data.articleList
        // this.getGoodss()
        this.userCount = res.data.userCount
        this.deptCount = res.data.deptCount
        this.userActivityTimeLong = res.data.userActivityTimeLong
        this.userActivityCount = res.data.userActivityCount
      }).then(() => {
        return getLoginUser()
      }).then(res => {
        this.user = res.data
      }).finally(() => {
        this.$modal.closeLoading()
      })
    }
    ,
    goToActivity() {
      this.$router.push({
        path: '/activity'
      });
    }
    ,
    goToArtlist() {
      this.$router.push({
        path: '/home/Artlist'
      });
    }
    ,
    goToEnterlist() {
      this.$router.push({
        path: '/home/Enterlist'
      });
    }
    ,
    goToSpeedlist() {
      this.$router.push({
        path: '/home/Speedlist'
      });
    }
    ,
    goToSignday() {
      this.$router.push({
        path: '/home/Signday'
      });
    }
    ,
    goToArtdea(id) {
      upArticleById(id).then(res => {
        this.$router.push({
          path: '/home/Artdea',
          query: {
            id: id
          }
        });
      })
    }
    ,
    goToLame() {
      this.$router.push({
        path: '/home/Lame'
      });
    }
    ,
    goToActiday() {
      this.$router.push({
        path: '/home/Actiday'
      });
    }
    ,
    goToActivdea(id) {
      this.$router.push({
        path: '/activity/Activdea/',
        query: {
          id: id
        }
      });
    }
    ,
    goToJoin() {
      this.$router.push({
        path: '/home/Join'
      });
    }
    ,
    goToExchange() {
      this.$router.push({
        path: '/home/Exchange'
      });
    }
    ,
//加密
    encrypt(txt) {
      const encryptor = new JSEncrypt()
      encryptor.setPublicKey(publicKey) // 设置公钥
      return encryptor.encrypt(txt) // 对数据进行加密
    }
    ,
//轮播图外部链接
    bannerLink(link) {
      if (link == null || link == undefined || link == '') {
        return
      } else {
        window.location.href = link
      }
    }
    ,
    /**
     * 团队排行
     * @constructor
     */
    GotoRanking() {
      this.$router.push({
        path: '/home/ranking'
      });
    }
    ,
    /**
     * 个人排行
     * @constructor
     */
    GotoRankingPersonnel() {
      this.$router.push({
        path: '/home/rankingPersonnel'
      });
    }
  }
}
</script>
<style scoped="scoped">
>>> .van-swipe {
  font-size: 0;
  border-radius: 5px;
}

.q_icon_home >>> .van-image {
  height: 45px;
  width: 45px;
}

.van-swipe .van-image {
  height: 115px;
}

.q_acti {
  width: 160px;
  display: inline-block;
  margin-right: 15px;
}

.q_acti >>> .van-image {
  width: 160px;
  height: 90px;
}

.q_acti >>> .van-image .van-image__img,
.q_act_img >>> .van-image__img {
  border-radius: 5px;
}

.q_acti >>> .van-button {
  letter-spacing: 1px;
  padding: 0 12px;
}

.q_act_img {
  width: 110px;
  height: 62px !important;
}

.q_new_ond >>> .van-swipe__indicators {
  bottom: 0;
}

.q_new_ond >>> .van-swipe__indicator {
  width: 16px;
  height: 4px;
  border-radius: 2px;
}

.q_store {
  display: inline-block;
  width: 50%;
  margin-bottom: 15px;
}

.q_store >>> .van-image {
  width: 165.5px;
  height: 165.5px;
  border-radius: 5px;
}

.q_store >>> .van-image__img {
  width: 165.5px;
  height: 165.5px;
  border-radius: 5px;
}

.q_moit1 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

>>> .van-button__text {
  font-weight: 700;
}
</style>
